module.exports = __webpack_public_path__ + "img/送出外发.f07ca62f.svg";